export default "__VITE_ASSET__BQjREVaS__"